import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getExistingSubmissionsDialogVisible,
  getExistingSubmissionsEmail,
  getNextIncompleteStep,
  getProgramKey,
  getProjectKey,
} from "common/selectors";
import {
  showExistingSubmissionsDialog,
  setActiveStep,
} from "submission/submissionActions";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import IntlDialogActions from "../../general-components/IntlDialogActions";
import * as steps from "common/steps";

const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;
const ENV = process.env.REACT_APP_CLIENT_ENVIRONMENT;

const ExistingSubmissionsDialog = () => {
  const { t } = useTranslation();
  const visible = useSelector(getExistingSubmissionsDialogVisible);
  const email = useSelector(getExistingSubmissionsEmail);
  const nextStep = useSelector(getNextIncompleteStep);
  const programKey =
    useSelector(getProgramKey) ??
    (ENV === "test" ? "bibliolabs" : "indieauthorproject");
  const projectKey =
    useSelector(getProjectKey) ?? (ENV === "test" ? "albums" : "iap");
  const dispatch = useDispatch();

  const onRedirect = () => {
    window.location.href = `${STIP_BASE_URL}/resubmit-pages/${programKey}/${projectKey}?emailAddress=${encodeURIComponent(
      email,
    )}`;
  };

  const onDismiss = () => {
    dispatch(showExistingSubmissionsDialog(false));
  };

  const onContinue = () => {
    dispatch(showExistingSubmissionsDialog(false));
    dispatch(setActiveStep(nextStep || steps.FILE_UPLOAD));
  };

  return (
    <Dialog open={visible} onClose={onDismiss}>
      <DialogTitle>{t("existing_submissions_dialog_title", "Good News! We Found Existing Books.")}</DialogTitle>
      <DialogContent>
        <DialogContentText color="primary">
          {t("existing_submissions_dialog_message_one", "It looks like you already have books in the Indie Author Project. You can easily submit one of those titles to the contest without uploading it again.")}
          <br />
          <br />
          {t("existing_submissions_dialog_message_two", "Choose a book from your existing titles or upload a new file if you're submitting something different.")}
        </DialogContentText>
      </DialogContent>
      <IntlDialogActions>
        <Button variant="contained" color="secondary" onClick={onRedirect}>
          {t("existing_submissions_dialog_redirect", "Select an Existing Book")}
        </Button>
        <Button color="primary" onClick={onContinue}>
          {t("existing_submissions_dialog_continue", "Continue New Submission")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default ExistingSubmissionsDialog;
